import React, { useEffect, useState } from "react";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import useAxios from "../../../hooks/useAxios";
import { __fetchPWGPlans } from "../../../api/sim";

/**
 * Dropdown of the configured PWG plans. The selected plan_id is applied to
 * every line of the batch, so lines don't carry a plan id themselves.
 */
const PwgPlanSelect = ({ value, onChange, label = "Plan" }) => {
  const [plans, setPlans] = useState([]);
  const [response, call, loading] = useAxios({ ...__fetchPWGPlans });

  useEffect(() => {
    call({ params: { page: 1, page_size: 10000 } });
  }, []);

  useEffect(() => {
    if (response && response.status) {
      setPlans(response.data.data);
    }
  }, [response]);

  return (
    <TextField
      select
      fullWidth
      label={label}
      value={value}
      disabled={loading}
      onChange={(e) => onChange(e.target.value)}
      helperText={!loading && !plans.length ? "No plans configured" : ""}
    >
      {plans.map((plan) => (
        <MenuItem key={plan.id} value={plan.plan_id}>
          {`${plan.plan_name} (${plan.plan_id})`}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default PwgPlanSelect;
